function checkForStorage() {
  if (typeof window.hasStorage === 'undefined') {
    const storage = (function checkStorage() {
      try {
        const test = 'test';
        localStorage.setItem(test, test);
        localStorage.removeItem(test);
        return true;
      } catch (e) {
        return false;
      }
    }());
    window.hasStorage = storage;
  }

  return window.hasStorage;
}

export default checkForStorage();
